import React, { useEffect } from 'react'
import { Route, Routes, useParams, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { usePageActionsContext } from 'src/Libs/header/context'
import { useSystemDetailsTabs } from 'src/Libs/service-dashboard/hooks/use-system-details-tabs'
import { setActiveInstallation } from 'src/State/Storage/StorageActions'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'

const InstallationDetailsRoute: React.FC = () => {
  const { t } = useCustomTranslation()
  const dispatch = useDispatch()
  const { dispatchPageActions } = usePageActionsContext()
  const navigate = useNavigate()

  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()
  const { tabs } = useSystemDetailsTabs(installationId, storageId)

  useEffect(() => {
    dispatchPageActions?.([{ position: 'left', type: 'back', onClick: () => navigate(-1) }])

    return () => {
      dispatchPageActions?.([])
    }
  }, [dispatchPageActions, navigate])

  useEffect(() => {
    const installationIdToUse = installationId ? parseInt(installationId) : undefined
    dispatch(setActiveInstallation(installationIdToUse, storageId))
  }, [dispatch, installationId, storageId])

  useEffect(() => {
    dispatch(appUpdate({ title: t('system-details.title', { serialno: storageId }) }))
  }, []) //eslint-disable-line

  return (
    <Routes>
      {tabs
        .filter(tab => !tab.disabled)
        .map(tab => (
          <Route key={tab.href} path={tab.componentHref} element={tab.component} />
        ))}
    </Routes>
  )
}

export default InstallationDetailsRoute
